// The Send to Chart / Create Chart / Create Task drawer (DynamicEhrDrawer) has no
// mask, so the slide-out viewer and the inbox stay usable while it is open: Next/
// Previous Record and opening another row switch the document on screen. The drawer
// is bound to the record it was opened for (its prefilled patient, its patient search
// and the send token Submit files), so it must not stay up beside a different
// document. As with the chart modals (reducers/modal), it reloads instead: it swaps to
// an empty "Loading record…" drawer, and the slide-out's ChartActionsDropdown opens it
// again from the new record once that record's details load.

export const CLOSED_EHR_DRAWER = {
  ehrDrawerVisible: false,
  ehrDrawerData: null,
  ehrDrawerReload: null,
};

const boundSendToken = ({ ehrDrawerData, ehrDrawerReload }) => (
  ehrDrawerReload ? ehrDrawerReload.sendToken : ehrDrawerData?.sendToken
);

// The drawer state once the slide-out viewer's record has changed to the record
// with `viewerSendToken` (none: the viewer closed), or null to leave the drawer be.
// `viewerRecordRestricted`: that record is a restricted patient split.
export const ehrDrawerAfterViewerRecordChange = (state, viewerSendToken, viewerRecordRestricted = false) => {
  if (!state.ehrDrawerVisible) return null;

  // The viewer closed. A loaded drawer still matches its own record and no other
  // document is on screen, so it stays; a pending reload has nothing to reopen it.
  if (!viewerSendToken) return state.ehrDrawerReload ? CLOSED_EHR_DRAWER : null;

  if (viewerSendToken === boundSendToken(state)) return null;

  // The slide-out offers no chart actions for a restricted patient split, so nothing
  // would reopen the drawer. Its toolbar unmounts in this same update, before this
  // runs, so its unmount cleanup can't cancel a placeholder made here: close instead.
  if (viewerRecordRestricted) return CLOSED_EHR_DRAWER;

  return {
    ehrDrawerData: null,
    ehrDrawerReload: {
      workflow: state.ehrDrawerReload?.workflow || state.ehrDrawerData?.workflow || 'send_to_chart',
      sendToken: viewerSendToken,
    },
    // A new drawer instance, so nothing typed, searched or fetched for the last
    // record survives into this one. A placeholder holds none, so it is kept.
    ehrDrawerKey: state.ehrDrawerReload ? state.ehrDrawerKey : state.ehrDrawerKey + 1,
  };
};
